import { useEffect } from 'react';

// Landing page for the Instagram Business Login popup redirect.
// Reads ?code= (or ?error=) and posts it back to the opener window, then closes.
export const InstagramCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error_description') || params.get('error');

    if (window.opener) {
      window.opener.postMessage(
        { source: 'ig-connect', code: code || undefined, error: error || undefined },
        window.location.origin
      );
      window.close();
    }
  }, []);

  return null;
};
